module.exports = __webpack_public_path__ + "img/icon-footer-youtube.ac660960.jpg";